<script>
    import { Tooltip } from 'sveltestrap';

    export let level;
    export let tooltipId = undefined; 
    export let tooltipText = undefined;
</script>

<span class="badge badge-level" id={tooltipId} 
      class:badge-danger={level == 'H'}
      class:badge-warning={level == 'M'}
      class:badge-success={level == 'L'}>
      {#if level == 'H'}High{/if}
      {#if level == 'M'}Medium{/if}
      {#if level == 'L'}Low{/if}
</span>
{#if tooltipText && tooltipId}
    <Tooltip target="{tooltipId}" placement="bottom">{tooltipText}</Tooltip>
{/if}